import positionService from "@libs/services/PositionService";
import { observable } from "mobx";

export default class PositionAutoComplete {
  @observable footballPositions = [];

  async fetchFootballPosition(params) {
    this.footballPositions = await positionService.fetchAutoCompletePositions(params);
  }
}